module.exports = __webpack_public_path__ + "images/kihnu/routes/KEL-LEP-KEL.png";